
import React, { useState } from 'react';
import { auth } from '../firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';

export default function Login(){
  const [email,setEmail]=useState('');
  const [password,setPassword]=useState('');
  const [mode,setMode]=useState('signin');
  const submit=async(e)=>{
    e.preventDefault();
    if(!/@ezarecycling\.com$/i.test(email)) return alert('Use your @ezarecycling.com email.');
    try{
      if(mode==='signup') await createUserWithEmailAndPassword(auth,email,password);
      else await signInWithEmailAndPassword(auth,email,password);
    }catch(e){alert(e.message);}
  };
  return(<div style={{maxWidth:360,margin:'40px auto'}} className='card'>
    <h3>{mode==='signup'?'Create your account':'Sign In'}</h3>
    <form onSubmit={submit} className='form'>
      <label>Email (@ezarecycling.com)</label>
      <input value={email} onChange={e=>setEmail(e.target.value)} />
      <label>Password</label>
      <input type='password' value={password} onChange={e=>setPassword(e.target.value)} />
      <div className='form-actions'>
        <button className='btn primary' type='submit'>{mode==='signup'?'Sign Up':'Sign In'}</button>
        <button className='btn' type='button' onClick={()=>setMode(mode==='signup'?'signin':'signup')}>
          {mode==='signup'?'Have an account? Sign In':'Need an account? Sign Up'}
        </button>
      </div>
    </form>
  </div>);
}
